import React, { createContext, useContext, ReactNode } from "react";
import { NavigationBar } from "./navigation-bar";
import type { Session, SupabaseClient } from "@supabase/supabase-js";
type Role = "admin" | "user";

type NavigationBarContextType = {};

const NavigationBarContext = createContext<
  NavigationBarContextType | undefined
>(undefined);

interface NavigationBarProviderProps {
  children: ReactNode;
}

export const NavigationBarProvider = (props: NavigationBarProviderProps) => {
  return (
    <NavigationBarContext.Provider value={{}}>
      <NavigationBar></NavigationBar>
      {props.children}
    </NavigationBarContext.Provider>
  );
};

export const useNavigationBarContext = (): NavigationBarContextType => {
  const context = useContext(NavigationBarContext);
  if (!context) {
    throw new Error(
      "useNavigationBarContext must be used within an NavigationBarProvider"
    );
  }
  return context;
};
